export type HorseStatus = 'WAITING' | 'TRAINING' | 'TRAINED' | 'PROSPECT'

const horseStatuses: { key: HorseStatus, text: string }[] = [
  { key: 'TRAINING', text: 'À l\'entraînement' },
  { key: 'TRAINED', text: 'Sortant de l\'entraînement' },
]

const horseStatusObject = {} as Record<HorseStatus, string>
horseStatuses.forEach((e) => {
  horseStatusObject[e.key] = e.text
})

export function getHorseStatusLabel(key?: HorseStatus): string | undefined {
  return key && horseStatusObject[key]
}

export default horseStatuses
